import { render, staticRenderFns } from "./photoArticle.vue?vue&type=template&id=50b8e3ae&"
import script from "./photoArticle.vue?vue&type=script&lang=js&"
export * from "./photoArticle.vue?vue&type=script&lang=js&"
import style0 from "./photoArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports